import React, { FC } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy';

import Link from 'buyside/components/presentation/Link/link';

import { defaultUserImageUrl, ideaUrl } from 'buyside/util/urlHelper';

import { useTopStockWinnersQuery } from 'interfaces/graphql-typings';

import styles from './eventSpeakersStyles.scss';

export enum Props {
  Keynote = 'Keynote',
  StockPitch = 'Stock Pitch',
  VCPanel = 'VC Panel'
}
type SpeakerType = {
  category?: string;
  firm?: string;
  image?: string;
  name?: string;
  ideaId?: string;
}[];

const speakersMap: { [key in Props]: SpeakerType } = {
  Keynote: [
    {
      name: 'Dan Rasmussen',
      firm: 'Founder & Portfolio Manager of Verdad Advisers',
      image: '/images/event/speakers/DanRasmussen.jpeg'
    }
  ],
  'Stock Pitch': [
    {
      name: 'Scott Miller',
      firm: 'Greenhaven Road Capital',
      image: '/images/event/speakers/ScottMiller.jpeg'
    },
    { name: 'Nitin Sacheti', firm: 'Papyrus Capital', image: '/images/event/speakers/Nitin.jpg' },
    {
      name: 'Edward Robson',
      firm: '2717 Capital',
      image: '/images/event/speakers/EdwardRobson.png'
    },
    {
      name: 'Eric DeLamarter',
      firm: 'Half Moon Capital',
      image: '/images/event/speakers/EDeLamarter.jpg'
    },
    { name: 'Raj Shah', firm: 'Stoic Point', image: '/images/event/speakers/RajShah.jpg' }
  ],
  'VC Panel': [
    {
      name: 'Jordan Fliegel',
      firm: 'Shareholder Ventures',
      image: '/images/event/speakers/JordanFliegel.jpeg'
    },
    { name: 'Jason Shuman', firm: 'Primary VC', image: '/images/event/speakers/JasonSchuman.jpeg' },
    { name: 'Dorothy Chang', firm: 'Flybridge', image: '/images/event/speakers/DorothyChang.jpeg' },
    {
      name: 'Semyon Dukach',
      firm: 'One Way Ventures',
      image: '/images/event/speakers/SemyonDukach.jpeg'
    },
    {
      name: 'Sarah Hoffman',
      firm: 'AlphaSense',
      image: '/images/event/speakers/SarahHoffman.jpeg'
    }
  ]
};

// const guestSpeakers: SpeakerType = [
//   {
//     category: 'Rising Star Winner',
//     ideaId: '23214'
//   },
//   { category: 'Small Cap Winner', ideaId: '23125' },
//   { category: 'Mid Cap Winner', ideaId: '23149' },
//   { category: 'Large Cap Winner', ideaId: '23105' },
//   {
//     category: 'Special Sits Winner',
//     ideaId: '23222'
//   },
//   { category: 'Ex US Winner', ideaId: '23027' }
// ];

const EventSpeakers: FC<{
  type: Props;
}> = ({ type }) => {
  // const { data, error } = useTopStockWinnersQuery({ skip: keynote });
  const { data, error } = useTopStockWinnersQuery({ skip: true });

  if (error) throw error;

  const speakerList = speakersMap[type];

  return (
    <div id={type} className={styles.speakersContainer}>
      {/* <div className={styles.heading}>{keynote ? 'Keynote Speakers' : 'Contest Winners'}</div> */}
      <div className={styles.heading}>{type}</div>
      <div className={styles.speakers}>
        {speakerList.map((speaker, idx) => {
          const idea = data?.topStockWinners?.find(idea => idea.id === speaker.ideaId);

          const speakerImage =
            idea?.user?.profileImageUrl || speaker.image || defaultUserImageUrl();
          const speakerName = idea?.user?.displayName || speaker.name;
          const employerName = idea?.user?.mostRecentEmployer?.employer?.name || speaker.firm;
          const entityName = idea?.entityName;

          return (
            <div className={styles.speaker} key={`${idx}-${type}`}>
              {speaker.category && <p className={styles.category}>{speaker.category}</p>}
              <img src={speakerImage} className={styles.speakerImage} />
              <p className={styles.speakerName}>{speakerName}</p>
              {employerName && <p className={styles.employerName}>{employerName}</p>}
              {idea?.id && (
                <Link to={ideaUrl(idea.id)} target="_blank">
                  <FontAwesomeIcon icon={faTrophy} />
                  {entityName}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default EventSpeakers;
